import { z } from 'zod';

export const CakeToOrderIncludedServiceModelSchema = z.object({
    name: z.string(),
    description: z.any().optional().nullable(),
});

export type CakeToOrderIncludedServiceModel
    = z.infer<typeof CakeToOrderIncludedServiceModelSchema>;
